import { Dialog, Typography, DialogContent, DialogActions, DialogTitle, Button, Stack, Box } from "@mui/material";
import { LockOpenRounded, LockRounded } from "@mui/icons-material";
import { fromUnixTime, isValid } from "date-fns";
import { formatLocalized } from "shell/i18n/dates";
import { useTranslation } from "react-i18next";
type LockedItemProps = {
  itemName: string;
  currentViewerFirstName: string;
  currentViewerLastName: string;
  viewTimestamp: string;
  onCancel: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  onUnlock: () => void;
};
export const LockedItem = ({
  itemName,
  currentViewerFirstName,
  currentViewerLastName,
  viewTimestamp,
  onCancel,
  onUnlock
}: LockedItemProps) => {
  const {
    t
  } = useTranslation();
  const d = fromUnixTime(Number(viewTimestamp));
  const viewedAt = isValid(d) ? formatLocalized(d, "MMMM do, yyyy h:mm a") : "";
  return <Dialog open PaperProps={{
    sx: {
      maxWidth: 540
    }
  }} data-sentry-element="Dialog" data-sentry-component="LockedItem" data-sentry-source-file="index.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="index.tsx">
        <Stack gap={1.5} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
          <Box sx={{
          backgroundColor: "warning.light",
          borderRadius: "100%",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <LockRounded color="warning" data-sentry-element="LockRounded" data-sentry-source-file="index.tsx" />
          </Box>
          <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Box mb={1} data-sentry-element="Box" data-sentry-source-file="index.tsx">
              <Typography variant="h5" display="inline" fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                {t("content.itemEditItemLockedTitle")}
                {":"}&nbsp;
              </Typography>
              <Typography variant="h5" display="inline" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                {itemName}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              {t("content.itemEditItemLockedDescription", {
              name: `${currentViewerFirstName} ${currentViewerLastName}`,
              firstName: currentViewerFirstName,
              viewedAt
            })}
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="index.tsx">
        <Button data-cy="LockedItemGoBack" variant="text" color="inherit" onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t("common.goBack")}
        </Button>
        <Button data-cy="LockedItemUnlock" variant="contained" color="warning" startIcon={<LockOpenRounded />} onClick={onUnlock} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t("content.itemEditUnlock")}
        </Button>
      </DialogActions>
    </Dialog>;
};